export default __webpack_public_path__ + "static/hero-5d9a2c2b08457ee7cc736e413051c40e.jpg";